import { NUMBER_SIZE } from '../../constants/size'

import { TAG_APPEARANCE, TAG_HEIGHT } from './Tag.constants'

export function isTagAppearanceFilled(appearance) {
  return appearance === TAG_APPEARANCE.filled
}

export function getTagActionSize(height) {
  return height >= TAG_HEIGHT.height32 ? NUMBER_SIZE.size24 : NUMBER_SIZE.size20
}

export function getTagStyle({
  backgroundColor,
  backgroundColorHover,
  removeIconColor,
  style,
  textColor,
  textColorHover,
}) {
  return {
    ...style,
    '--tag-background-color-base': backgroundColor,
    '--tag-background-color-hover-base': backgroundColorHover,
    '--tag-remove-icon-color-base': removeIconColor,
    '--tag-text-color-base': textColor,
    '--tag-text-color-hover-base': textColorHover,
  }
}
